import React from 'react';

import { CmsSectionsTypes } from 'models/Product';

import TextSimpleCmsSection from 'components/modules/public/cmsSections/sectionTypes/TextSimple';
import TwoColsSimpleCmsSection from 'components/modules/public/cmsSections/sectionTypes/TwoColsSimpleCmsSection';
import TwoColsSimpleInvertedCmsSection
    from 'components/modules/public/cmsSections/sectionTypes/TwoColsSimpleInvertedCmsSection';

import { Props } from './index';
import StyledComponent from './styles';

enum SectionTypes {
    TextSimple = 'textSimple',
    TwoColsSimpleCmsSection = 'twoColsSimple',
    TwoColsSimpleInvertedCmsSection = 'twoColsSimpleInverted',
}

const CmsSectionComponent: React.FC<Props> = ({ sections }): React.ReactElement => {
    const parseSection = (cmsSection: CmsSectionsTypes): React.ReactNode => {
        switch (cmsSection.sectionTypeName) {
            case SectionTypes.TwoColsSimpleCmsSection:
                return (
                    <TwoColsSimpleCmsSection section={cmsSection?.sectionData} />
                );
            case SectionTypes.TwoColsSimpleInvertedCmsSection:
                return (
                    <TwoColsSimpleInvertedCmsSection section={cmsSection?.sectionData} />
                );
            case SectionTypes.TextSimple:
                return (
                    <TextSimpleCmsSection section={cmsSection?.sectionData} />
                );
        }
    };

    const sortedSection = sections.sort((a, b) => (a.order > b.order) ? 1 : -1);

    return (
        <StyledComponent className="public-modules-cms-section">
            {sortedSection.map((section) => (
                <React.Fragment key={section.id}>
                    {parseSection(section)}
                </React.Fragment>
            ))}
        </StyledComponent>
    );
};

export default CmsSectionComponent;
